import {useMemo, useState} from "react";
import {RsoCaptchaSmartLogin} from "../../common/RsoCaptchaSmartLogin";

const CaptchaRule = {
  Never: "Never",
  Dynamic: "Dynamic",
  Always: "Always",
};

const allowedSteps = ["verify_password", "force_change_password"];

export const useCaptcha = ({
  application,
  responseCurrentStep,
  shouldReloadCaptcha,
}) => {
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaImg, setCaptchaImg] = useState("");
  const [clientSecret, setClientSecret] = useState("");

  const captchaProviders = useMemo(() => {
    return (
      application?.providers?.filter(
        (p) => p?.provider?.category === "Captcha"
      ) || []
    );
  }, [application]);

  const captchaRule = useMemo(() => {
    if (!captchaProviders.length) {return CaptchaRule.Never;}
    if (captchaProviders.some((p) => p.rule === "Always")) {return CaptchaRule.Always;}
    if (captchaProviders.some((p) => p.rule === "Dynamic")) {return CaptchaRule.Dynamic;}
    return CaptchaRule.Never;
  }, [captchaProviders]);

  const shouldShowCaptcha =
    allowedSteps.includes(responseCurrentStep) &&
    captchaRule !== CaptchaRule.Never;

  const provider =
    captchaProviders.find((p) => p.rule === "Always") ||
    captchaProviders.find((p) => p.rule === "Dynamic");

  const renderCaptcha = () => {
    if (!shouldShowCaptcha || !provider) {return null;}

    return (
      <RsoCaptchaSmartLogin
        shouldReloadCaptcha={shouldReloadCaptcha}
        owner={provider.provider.owner}
        name={provider.provider.name}
        captchaImg={captchaImg}
        captchaToken={captchaToken}
        setCaptchaToken={setCaptchaToken}
        setCaptchaImg={setCaptchaImg}
        setClientSecret={setClientSecret}
        isCurrentProvider
      />
    );
  };

  const isCaptchaValid = !shouldShowCaptcha || captchaToken.length === 5;

  return {
    captchaToken,
    captchaImg,
    clientSecret,
    isCaptchaValid,
    renderCaptcha,
  };
};
